var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6886 12.2725L14.1212 1.08448L13 0L4.29249 8.42186L0.31131 12.2725C-0.10377 12.6744 -0.10377 13.3255 0.31131 13.7275L8.2666 21.4218L13 26L21.7075 17.5781L21.8423 17.4478L25.6886 13.7275C26.1038 13.3255 26.1038 12.6744 25.6886 12.2725ZM13 16.8437L9.02589 13L13 9.15626L16.9741 13L13 16.8437Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 9.1562C10.398 6.63928 10.3853 2.56273 12.9715 0.0307617L4.27466 8.43888L9.00803 13.017L12.9999 9.1562Z",
    fill: "url(#paint0_linear_3113_6274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9847 12.9895L13 16.8434C14.2559 18.0575 14.9615 19.7044 14.9615 21.4216C14.9615 23.1389 14.2559 24.7858 13 25.9998L21.7182 17.5676L16.9847 12.9895Z",
    fill: "url(#paint1_linear_3113_6274)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3113_6274",
    x1: 12.2902,
    y1: 5.26783,
    x2: 5.66096,
    y2: 8.16225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3113_6274",
    x1: 13.7593,
    y1: 20.6872,
    x2: 20.3767,
    y2: 17.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIcon);
export default __webpack_public_path__ + "static/media/jira-icon.93410ee55189c312cc80ded8c0fffef6.svg";
export { ForwardRef as ReactComponent };